export type SizeType = 'w-full' | 'small' | 'medium' | 'normal' | 'large' | 'xlarge' | 'xxlarge';

class SizeTranslator {

	public static defaultWidth: string = 'w-20';

	public static translate(size: SizeType): string {
		switch (size) {
			case 'w-full' :
				return  'w-full';
			case 'small' :
				return  'w-20';
			case 'medium' :
				return  'w-32';
			case 'normal' :
				return  'w-48';
			case 'large' :
				return  'w-56';
			case 'xlarge' :
				return  'w-64';
			case 'xxlarge' :
				return  'w-86';
		}
	}
}

export default SizeTranslator;